import { graphql, useStaticQuery } from 'gatsby'

import { FreightCategoryType } from '@application/Types/ComponentTypes'
import { getPageUrl } from '@application/Utils/generalUtils'
import { localizeUrl } from '@infrastructure/Url/localizeUrls/localizeUtilities'

export const useGetGlobalFreightCategoriesList = (language = 'en'): FreightCategoryType[] => {
    const data = useStaticQuery(graphql`
        query {
            allStrapiGlobalFreightCategory(filter: { title: { regex: "/^((?!do-not-remove).)*$/" } }) {
                nodes {
                    items: global_freights {
                        title
                        pageUrl
                        legacyPageUrl
                        useLegacyPageUrl
                        language
                    }
                    language
                    title
                    description
                }
            }
        }
    `)

    const nodes: FreightCategoryType[] = data?.allStrapiGlobalFreightCategory.nodes.filter(
        (node: FreightCategoryType) => node.language === language
    )

    return nodes.map((node) => {
        return {
            ...node,
            items: node.items
                .filter((item) => item.language === language)
                .map((item) => ({ ...item, pageUrl: localizeUrl(language, getPageUrl(item)) })),
        }
    })
}
